import Cookies from 'js-cookie';

// Shared with the PHP system (sites/it), which reads and writes the same cookie.
const LANG_COOKIE = 'pos2u_lang';
const SUPPORTED_LANGUAGES = ['en', 'th', 'zh', 'my', 'lo'];
const ROOT_DOMAINS = ['pos2uapp.com', 'pos2uapp.net', 'pos2u.com'];

// Must match COOKIE_DOMAIN in the PHP index.php so both apps see one cookie.
// Other hosts (localhost, IPs) get a host-only cookie; ports do not isolate cookies.
export const getRootCookieDomain = (hostname: string): string | undefined => {
  const root = ROOT_DOMAINS.find(
    (d) => hostname === d || hostname.endsWith(`.${d}`)
  );
  return root ? `.${root}` : undefined;
};

export const getLanguageCookie = (): string | undefined => {
  const lang = Cookies.get(LANG_COOKIE);
  return lang && SUPPORTED_LANGUAGES.includes(lang) ? lang : undefined;
};

export const setLanguageCookie = (lang: string) => {
  if (!SUPPORTED_LANGUAGES.includes(lang)) return;
  // Not secure/httpOnly: PHP may run over http and must be able to overwrite it.
  Cookies.set(LANG_COOKIE, lang, {
    expires: 365,
    path: '/',
    sameSite: 'Lax',
    domain: getRootCookieDomain(window.location.hostname),
  });
};
